import { isEmpty } from 'lodash';
import React from 'react';

import ProcessDiscoveryLinkItem from './ProcessDiscoveryLinkItem';

interface DescriptorLinksProps {
  descriptors: any[];
  onLinkClick: (url: string) => void;
  newTableActions: string[];
}

const ProcessDisconveryDescriptorLinks = ({
  descriptors,
  onLinkClick,
  newTableActions,
}: DescriptorLinksProps) => {
  if (isEmpty(descriptors)) {
    return null;
  }
  const filteredDescriptors = isEmpty(newTableActions)
    ? descriptors
    : descriptors.filter((descriptor) => newTableActions.includes(descriptor.id));

  return (
    <div>
      <ul>
        {filteredDescriptors.map((entry, index) => (
          <ProcessDiscoveryLinkItem entry={entry} key={index} index={index} onLinkClick={onLinkClick} />
        ))}
      </ul>
    </div>
  );
};

export default ProcessDisconveryDescriptorLinks;
